import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

import { IHeaderItem, IPagination } from './../../../models/generic';
import {
  ReverseConfigDefaultHeaderItems,
  ReverseConfigDocumentHeaderItems
} from './../../../shared/utils/base';
import { ApiReverseConfigService } from './../../../services/api/api-reverse-config.service';
import { DialogEmailTypeEnum } from 'src/app/models/email';
import { ModalEstornoComponent } from './modal-estorno/modal-estorno.component';
import {
  IReverseConfig,
  IReverseConfigParameters
} from './../../../models/reverseConfig';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { SnackbarService } from './../../../services/snackbar.service';
import { ApiDialogService } from './../../../services/api/api-cdialog.service';

export enum ReverseConfiguration {
  DEFAULT = 'default',
  DOCUMENT = 'document'
}

@Component({
  selector: 'app-configuracoes-estorno',
  templateUrl: './configuracoes-estorno.component.html',
  styleUrls: ['./configuracoes-estorno.component.scss']
})
export class ConfiguracoesEstornoComponent implements OnInit {
  DialogEmailTypeEnum = DialogEmailTypeEnum;
  ReverseConfiguration = ReverseConfiguration;

  listReverseConfigType: string[] = ['default', 'document'];

  reverseConfigurations: {
    [key: string]: { reverseConfigurations: IReverseConfig[]; count: number };
  } = {
    [ReverseConfiguration.DEFAULT]: { reverseConfigurations: [], count: 0 },
    [ReverseConfiguration.DOCUMENT]: { reverseConfigurations: [], count: 0 }
  };

  reverseConfigHeaderItems: {
    [key: string]: IHeaderItem[];
  } = {
    [ReverseConfiguration.DEFAULT]: ReverseConfigDefaultHeaderItems,
    [ReverseConfiguration.DOCUMENT]: ReverseConfigDocumentHeaderItems
  };

  reverseParameters!: IReverseConfigParameters;

  skipDefault: number = 0;
  takeDefault: number = 10;

  skipDocument: number = 0;
  takeDocument: number = 10;

  constructor(
    private _dialog: MatDialog,
    private _reverseConfigService: ApiReverseConfigService,
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.getReverseConfigDefault();
    this.getReverseConfigHasDocument();
    this.getParametersReverseConfig();
  }

  getReverseConfigDefault(): void {
    this._reverseConfigService
      .getReverseConfig(this.skipDefault, this.takeDefault, false)
      .subscribe({
        next: (response) => {
          this.reverseConfigurations[ReverseConfiguration.DEFAULT] = {
            reverseConfigurations: [...response.Data],
            count: response.Count
          };
        }
      });
  }

  getReverseConfigHasDocument(): void {
    this._reverseConfigService
      .getReverseConfig(this.skipDocument, this.takeDocument, true)
      .subscribe({
        next: (response) => {
          this.reverseConfigurations[ReverseConfiguration.DOCUMENT] = {
            reverseConfigurations: [...response.Data],
            count: response.Count
          };
        }
      });
  }

  getParametersReverseConfig(): void {
    this._reverseConfigService.getParametersReverseConfig().subscribe({
      next: (response) => {
        this.reverseParameters = response;
      }
    });
  }

  openReverseConfigDialog(type: string, reverseConfig?: IReverseConfig): void {
    const dialogRef = this._dialog.open(ModalEstornoComponent, {
      data: { reverseConfig, reverseParameters: this.reverseParameters, type },
      panelClass: 'max-vh-95'
    });

    dialogRef.afterClosed().subscribe({
      next: (response: { reload: boolean; type: 'default' | 'document' }) => {
        if (response.reload) {
          switch (response.type) {
            case 'default':
              this.getReverseConfigDefault();
              break;

            case 'document':
              this.getReverseConfigHasDocument();
              break;
          }
        }
      }
    });
  }

  handlePagination(event: IPagination, type: string): void {
    switch (type) {
      case 'default':
        this.skipDefault = event.Skip;
        this.takeDefault = event.Take;
        this.getReverseConfigDefault();
        break;

      case 'document':
        this.skipDocument = event.Skip;
        this.takeDocument = event.Take;
        this.getReverseConfigHasDocument();
        break;
    }
  }

  handleOpenDialogDelete(type: string, reverseConfig: IReverseConfig): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Excluir configuração',
        title: 'Tem certeza que deseja excluir essa configuração?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) this.deleteStoreConfig(type, reverseConfig);
    });
  }

  deleteStoreConfig(type: string, reverseConfig: IReverseConfig): void {
    this._reverseConfigService
      .deleteReverseConfig(reverseConfig.ReversalParameterId!)
      .subscribe({
        next: (response) => {
          this._snackbarService.openSnackBar(
            'Configuração excluida com sucesso!',
            'success'
          );
          type === 'default'
            ? this.getReverseConfigDefault()
            : this.getReverseConfigHasDocument();
        }
      });
  }
}
